import React from 'react';

/**
 * usePC hook
 * Takes an object as a param
 * @param {object} settings 
 * @returns {array}
 */
export default function(settings) {
  const [sceneLoaded, setSceneLoaded] = React.useState(false); // If scene is ready
  const { event, callback, once, ref, debug } = settings;
  const savedCallback = React.useRef(null);
  const target = ref ? ref.current.contentWindow : window;

  // Send event to PlayCanvas
  function dispatchEvent(data) {
    target.pc.app.fire(event, data);
    
    if (debug) {
      console.log(`[usePC | Firing: ${event}]`);
      console.log('[usePC | Data:', data);
    }
  }

  /**
   * Handle callback to React
   */
  const handleCallback = React.useCallback((data) => {
    if(!savedCallback.current) return;
    savedCallback.current(data);

    if (debug) {
      console.log(`[usePC | Receiving: ${event}]`);
      console.log('[usePC | Data:', data);
    }

    if(!once) return;
    removeListener();
  }, [savedCallback]);

  /**
   * Set the listener
   */
  function setListener() {
    target.pc.app.on(event, handleCallback);

    if (debug) {
      console.log(`[usePC | Set listener: ${event}]`);
    }
  }

  /**
   * Remove the listener
   */
  function removeListener() {
    target.pc.app.off(event, handleCallback);

    if (debug) {
      console.log(`[usePC | Remove listener: ${event}]`);
    }
  }

  /**
   * Set callback
   */
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  /**
   * When the scene is loaded, trigger listener
   */
  React.useEffect(() => {
    if(!sceneLoaded) return;

    setListener();

    return () => removeListener();
  }, [sceneLoaded]);

  /**
   * Check so the PlayCanvas scene is loaded
   */
  React.useEffect(() => {
    if(sceneLoaded) return;

    let interval = setInterval(() => {
      if(!target.pc.app) return;

      // App is ready
      clearInterval(interval);
      setSceneLoaded(true);
    }, 200); 
    
  }, []);

  /**
   * Return
   */
  return [
    dispatchEvent,
    {
      sceneLoaded,
      resetListener: setListener
    }
  ];
}